import { Control, Controller } from "react-hook-form";

import { Button, Field, Input, Label } from "@web-app/components";
import ChecklistQuantity from "@web-app/pages/common/ChecklistQuantity";

import { FormValues } from "../types";

type ChecklistItem = FormValues["pickupChecklist"][number];

interface ItemChecklistFieldProps {
  control: Control<FormValues>;
  name: "dropoffChecklist" | "pickupChecklist";
  required?: boolean;
}

export default function ItemChecklistField({
  control,
  name,
  required,
}: ItemChecklistFieldProps) {
  return (
    <Field>
      <Label required={required}>Checklist</Label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const items: ChecklistItem[] = field.value ?? [];
          const updateItem = (index: number, changes: Partial<ChecklistItem>) =>
            field.onChange(
              items.map((item, i) =>
                i === index ? { ...item, ...changes } : item,
              ),
            );

          return (
            <div className="space-y-1.5">
              {items.map((item, index) => (
                <div key={index} className="flex items-center gap-1.5">
                  <Input
                    type="text"
                    size="xs"
                    placeholder="Item name"
                    value={item.label}
                    onChange={(value) => updateItem(index, { label: value })}
                  />
                  <ChecklistQuantity
                    quantity={item.quantity}
                    onChange={(quantity) => updateItem(index, { quantity })}
                  />
                  <Button
                    plain
                    size="2xs"
                    className="!p-1 text-gray-500"
                    iconClassName="!h-2.5 !w-2.5"
                    aria-label="Remove item"
                    icon="fasTrash"
                    onClick={() =>
                      field.onChange(items.filter((_, i) => i !== index))
                    }
                  />
                </div>
              ))}
              <Button
                plain
                size="sm"
                onClick={() =>
                  field.onChange([...items, { isChecked: false, label: "" }])
                }
              >
                + Add Item
              </Button>
            </div>
          );
        }}
      />
    </Field>
  );
}
